<template>
 <div class="L1Visa-main" style="padding:10px">
        <ob-spinner v-if="isLoading" loading-text="Loading..."></ob-spinner>
    <div v-else>
            <div v-if="L1VisaDocument.length != 0" class="L1Visa-header">
                <h4>L-1 Visa</h4>
            </div>
        <template>
           <div v-if="!isLoading && L1VisaDocument.length == 0" style="height: 400px;display:table;width:100%;">
                <div class="pfa-body" style="display: table-cell; vertical-align: middle;text-align: center;">
                    <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/Folder_icon.svg`" style="margin-bottom:20px;" /> 
                    <h5 class="pfa-info_msg">
                        Attention! The L-1 Visa folder does not contain any documents at the moment. Please contact your employer for clarification!
                    </h5>
                </div>
            </div>
            <div v-else>
                <div v-for="(l1DocObj, index) in L1VisaDocument" :key="index">
                    <ob-l1visa-document :documentObj="l1DocObj" :index="index" @removeDocument="getDocsList"> </ob-l1visa-document>
                </div> 
                <div v-for="(otherDocObj, oindex) in otherDocumentList" :key="`section-${oindex}`">
                    <ob-l1visa-document :documentObj="otherDocObj" @removeOtherDocument="getDocsList"> </ob-l1visa-document>
                </div>          
               
            </div> 
        </template>
    </div>
 </div>
</template>

<script>
 
    export default {
        data() {
            return { 
                isLoading:false,
                doValidation: false,
                isFormValid: false,
                L1VisaDocument: [],
                otherDocumentList: [],
                L1visaDocumentUrl:'',
                EmployeeId:'',
                openUploadL1E3TN:false,
                openOtherDocUpload:false,
                documentsData:{},
                documentId:"",
                isUpdate:false,
                isUpdateOtherDoc:false,
                isI94Only:false,
                indexValue:0,
                openL1PopupFromBanner:'',
                emptySection: false
            }
        },
        methods: {
            getDocsList(){
                  
                    this.isLoading = true
                    ajax.get(`Employee/${loggedInUserObj.empId}/GetL1E3TNDocuments`,{},(res) => {
                        if (res.data.State == true) {
                            this.isLoading = false
                            this.L1VisaDocument = []
                            this.otherDocumentList = []
                            this.documentsData = res.data.Documents
                            
                            if(res.data.Documents.DocList != null && res.data.Documents.DocList != '' && res.data.Documents.DocList.length > 0){
                                this.L1VisaDocument = res.data.Documents.DocList
                            }
                            if(res.data.Documents.OtherDocList != null && res.data.Documents.OtherDocList != '' && res.data.Documents.OtherDocList.length > 0){
                                this.otherDocumentList = res.data.Documents.OtherDocList
                            }
                            
                        }
                        else{
                            this.isLoading = false
                            this.$message({
                                type: "error",
                                message: res.data.Message
                            });
                        }
                    })
                
                
              
            
            },
            
        }, 
        computed: {            
           
        },        
       created() {
            this.getDocsList()
           
        },
         watch: {
           emptySection(){
           } 
        },
          
    }
</script>
<style lang="scss" scoped>
@import "~styles/framework/vue-utils";

    @import "~styles/framework/bootstrap/progress-bars";

    $default-border-color : #c2c2c2; $default-background-color: #fdfdfd; $success-border-color : #a4f3b5; $success-background-color: #f4fef7; .document-list {
        /*border-bottom: 1px dashed #ccc;*/
        padding: 15px 10px 15px 0px;
    }
.L1Visa-main {
    .L1Visa-header
    {
        display: inline-block;
        width: calc(100% - 30px);
        padding: 15px 0;
        border-bottom: dashed 1.4px #b5b5b5;
        margin: 0 15px;
        h4
        {
            display: inline-block;
            color: #143361;
            font-weight: bold;
        }
        .init-button {
            display: inline-block;
            float: right;
        }
    }
    .L1Visa-body {
        padding: 22px;
        display: inline-block;
        text-align: center;
        .L1Visa-info_msg
        {
            margin: 0;
            color: #a29f9f;
            font-weight: 600;
            font-size: 13px;
            line-height: 20px;
            text-align: center;
        }

    }
}  
.document-list__heading {
        padding: 5px 10px;
        border: 1px solid $default-border-color;
        display: inline-block;
        border-radius: 30px;
        font-weight: bold;
        background: $default-background-color;
        float: left;
    }

    .document-list__status {
        background: $default-border-color;
        color: $default-background-color;
        padding: 0px 5px;
        border-radius: 100%;
    }
    // .section{
    //     padding: 0px;
    //     border-bottom: 1px dashed #b5b5b5;
    // }
    .document-list__controls {
        float: right;
        top: 15px;
        position: absolute;
        right: 15px;
    }
    .upload-list__controls {
        float: right;
        top: 15px;
        right: 15px;
    }

    .document-list.document-list--success {
        .document-list__heading
        {
            border: 1px solid #1DC942;
            background: $success-background-color;
            margin-left: 1%;
        }
        .document-list__status {
            background: $success-border-color;
            color: #1DC942;
        }

    } 
    .file_name_span {
        //overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        //max-width: 600px;
        display: inline-block;
    }
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/EmpL1Visa.vue